import { ReactNode, createContext, useContext, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { noop } from 'lodash';

interface IClinicalEventsContextData {
  clinicalEventUuid?: string;
  isNewItem?: boolean;
}

const contextInitialValue = {
  clinicalEventUuid: '',
  isNewItem: false,
};

const clinicalEventsModalContext = createContext<{
  contextData: IClinicalEventsContextData;
  setContextData(data?: IClinicalEventsContextData): void;
}>({
  contextData: contextInitialValue,
  setContextData: noop,
});

const ClinicalEventModalProvider = ({ children }: { children: ReactNode }) => {
  const [data, setData] =
    useState<IClinicalEventsContextData>(contextInitialValue);
  return (
    <clinicalEventsModalContext.Provider
      value={{
        contextData: data ?? {},
        setContextData: (contextData: IClinicalEventsContextData) =>
          setData(contextData),
      }}>
      {children}
    </clinicalEventsModalContext.Provider>
  );
};

export default observer(ClinicalEventModalProvider);

export const useClinicalEventsModal = () =>
  useContext(clinicalEventsModalContext);
